/* eslint-disable sort-keys-fix/sort-keys-fix */

export const QBRFIRSTREPORTS = {
    AppClassificationScore: {
        key: `qbrQBRFirstAppClassificationScore`,
        name: 'Application Classification Score'
    },
    ManagedAppScore: {
        key: `qbrQBRFirstManagedAppScore`,
        name: 'Managed Application Score'
    },
    ShadowITScore: {
        key: `qbrQBRFirstShadowITScore`,
        name: 'Unclassified Application Score'
    },
    UnapprovedAppScore: {
        key: `qbrQBRFirstUnapprovedAppScore`,
        name: 'Unapproved Application Score'
    },
    AppOverlapScore: {
        key: `qbrQBRFirstAppOverlapScore`,
        name: 'Application Overlap Score'
    },
    SaaSSophisticationScore: {
        key: `qbrQBRFirstSaaSSophisticationScore`,
        name: 'SaaS Health Score'
    }
};
